import { render, staticRenderFns } from "./CommonAccordion.vue?vue&type=template&id=7296f8fe&scoped=true"
import script from "./CommonAccordion.vue?vue&type=script&lang=js"
export * from "./CommonAccordion.vue?vue&type=script&lang=js"
import style0 from "./CommonAccordion.vue?vue&type=style&index=0&id=7296f8fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296f8fe",
  null
  
)

export default component.exports